<template>
 <div>
   <div class="headline">{{name}}</div>
 </div>
</template>

<script>
    export default {
      props: ['name']
    }
</script>

<style scoped>
.headline{
  margin: 20px;
}
</style>